export enum SensorStatus {
  UNKNOWNSENSORSTATUS = 'UNKNOWN_SENSOR_STATUS',
  UNINITIALIZED = 'UNINITIALIZED',
  RUNNING = 'RUNNING',
  SUSPENDED = 'SUSPENDED'
}
